import React, { useState } from "react";
import { Container } from "react-bootstrap";
import img from "../../../assets/images/contact-image.png";
import { ownOptions } from "../../../util/constants";
import SelectOption from "../SolarSelectOption";
import { Spring } from "react-spring/renderprops";
import "../../multi-step-components/SelectInsuranceOption";
import "./styles.scss";

const OwnHomeQuestion = ({ setStep, roofData, setRoofData }) => {
  const [owner, setOwner] = useState(false);

  const handleContinueClick = () => {
    setRoofData({
      ...roofData,
      houseOwner: owner,
    });
    setStep(2);
  };

  return (
    <>
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: 1 }}
        config={{ duration: 1500 }}
      >
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <span>
              {" "}
              <div>
                <img src={img} className="toast-image" alt="Helper Profile " />
              </div>
              <h5 className="insurance-header"> Do You Own Your Home?</h5>
            </span>
            <div>
              <div className=" own-options-section roof-selection-section">
                {ownOptions.map((option) => (
                  <SelectOption
                    key={option.name}
                    type={option.name}
                    image={option.image}
                    activeImage={option.activeImage}
                    handleClick={setOwner}
                    selected={owner === option.name}
                  />
                ))}
              </div>
            </div>
            {owner ? (
              <div
                style={{
                  width: "90%",
                }}
                className="text-center mt-3 m-auto"
              >
                <button
                  onClick={() => handleContinueClick()}
                  className=" own-home-btn  sunroof-primary-btn m-auto btn-primary btn"
                >
                  Continue
                </button>
              </div>
            ) : null}
          </Container>
        )}
      </Spring>
    </>
  );
};

export default OwnHomeQuestion;
